/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useRef, useState } from 'react';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import FilterBtn from '../Filter';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import AnimatedButton from '../Animation/AnimatedButton';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import ExportFn from '../Export';
import GlobalContext from '../Context/GloablContext';
import { useContext } from 'react';
import OrgActivityExportFn from '../../pages/ManageOrganizations/ManageOrganizationActivityHistory/Components/Export';
import HelpGuideModal from '../HelpGuideModal';
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
import { handleSidebarPrvState } from '../../redux/systemConfigSlice';
import { getAuthItem } from '../../CommonMethods/authSession';

const TopBar = ({
    title,
    path,
    organization,
    pathPlaceholder,
    SearchInput,
    AddButton,
    menuBar,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    suggestions,
    setSuggestions,
    optimizedFn,
    setFilterValues,
    filterValues,
    initialState,
    SearchPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    toAddScreen,
    isExport,
    orgActivityExport,
    viewExportHistory,
    setConfirmationState,
    data,exportUsers,
    exportOrgUsers,isIdexport,
    isFilterOrganization,
    adminOrCorporateExport,
    AdminCorporateSearch,
    searchAdminCorporate}) => {
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,setIsSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    const navigate=useNavigate()
    const fileInputRef = useRef(null);
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isChangeStatusOPenxl, setIsChangeStatusOpenxl] = useState(false)    
    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const selectedRows = useSelector(state => state?.MultiSelectSlice?.selectedRows?.selectedIds)
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const ref = useRef()
    const ref2 = useRef()
    const dispatch = useDispatch()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType = getAuthItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })
    useOnClickOutside(ref2, () => {
        setIsChangeStatusOpenxl(false)
    })

    const handleOpenFilter = () => {
        if(isFilterOrganization){
            if((searchParams.get("start_date")!==null||searchParams.get("end_date")!==null)&&!isFilterOpen){
                setFilterValues(filtervals)
            }
            else if(searchParams.get("start_date")===null&&searchParams.get("end_date")===null){
                setFilterValues({
                    "filter_start_date":'',
                    "filter_end_date":'',
                })
            }

        }else{
            if((searchParams.get("field")!==null||searchParams.get("action")!==null||searchParams.get("start_date")!==null||searchParams.get("end_date")!==null)&&!isFilterOpen){
                setFilterValues(filtervals)
            }
            else if(searchParams.get("field")===null&&searchParams.get("action")===null&&searchParams.get("start_date")===null&&searchParams.get("end_date")===null){
                setFilterValues({
                    "filter_start_date":'',
                    "filter_end_date":'',
                    'column_field':'',
                    'action_performed':''
                })
            }

        }
        
        setIsFilterOpen(!isFilterOpen)
    }

    useEffect(() => {
        if(organization){
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=admin-list-organizations');
            } else {
                setQueryParamsadmin('type=admin-list-organizations');
            }
        }else{
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-list-admin-users');
            } else {
                setQueryParamsadmin('type=admin-list-admin-corporate-users');
            }
        }
        
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    function handleActivateClick(status) {
        if (selectedRows.map((item) => item.name).length > 50) {
            setToastErrorMessage(`You cannot ${status} more than 50 users at once`)
            setIsChangeStatusOpen(false)
            return
        }
        setIsChangeStatusOpen(false)
        if (status === "activate") {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'active', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
        else {
            setConfirmationState((prev) => ({ ...prev, isOpen: selectedRows.map((item) => item.name).length > 50 ? false : true, multirow: 'deactive', rowData: "", user_names: selectedRows.map((item) => item.name) }))
        }
    }    
    

    // Function to handle onClick logic
    const handleSearchClick = () => {
        
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
  
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };
  
    return (
        <>
            <div className="flex justify-between items-center">
                <div className='flex items-center mb-[14px]'>
                    {title!==undefined ?
                        <h1 className="text-xl font-normal text-[#000000] 2xl:self-center 2xl:pt-0 pt-2 self-start min-w-max">{title}</h1>
                        :
                        pathPlaceholder &&
                        <Link to={path} state={username && path !== '/manage-admin-corporate/' ? [username] : null} className='items-center min-w-max flex'>
                            <span><img loading='lazy' decoding='async' src="/images/back_button_Green.svg" alt="icon" /></span>
                            <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                        </Link>
                    }
                    {
                        (userType !=='super-admin' && !pathPlaceholder) &&
                        <span   onClick={() => setHelpGuideModel(true)} className=' ml-2 min-w-fit cursor-pointer'>
                            <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                        </span> 
                    }

                </div>

                
                <div className="flex items-center w-fit justify-end relative 2xl:flex-nowrap flex-wrap">
                    <div className='xl:block hidden'>
                        {menuBar && <div className='relative mb-[14px]'>
                            <button id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[10px] hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPen ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                                onClick={() => { setIsChangeStatusOpen(!isChangeStatusOPen) ,setIsFilterOpen!==undefined&&setIsFilterOpen(false)}}
                                onMouseEnter={() => setIsHover(true)}
                                onMouseLeave={() => setIsHover(false)}
                            >
                                {
                                    isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> : <img src="/images/3_dots_color.svg" alt="img" />

                                }
                            </button>
                            {isChangeStatusOPen && <ul ref={ref} className='px-1.5 py-3 rounded-[6px] absolute top-12 right-5 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                                <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Change Status</li>
                                <li>
                                    <ul>
                                        <li>
                                            <AnimatedButton
                                                handleClick={(e) => { handleActivateClick("activate") }}
                                                buttonName={"Activate"}
                                                disabled={(selectedRows?.filter((user)=>user.status==='inactive'))?.map((item)=>item.name).length===0?true:false}
                                                className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user)=>user.status==='inactive'))?.map((item)=>item.name).length===0?'text-[#6e6d6d]':'hover:text-[#008586] text-[#000000] cursor-pointer'} `}
                                            />
                                        </li>
                                        <li>
                                            <AnimatedButton
                                                handleClick={(e) => { handleActivateClick("deactivate") }}
                                                buttonName={"Deactivate"}
                                                disabled={(selectedRows?.filter((user)=>user.status==='active'))?.map((item)=>item.name).length===0?true:false}
                                                className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user)=>user.status==='active'))?.map((item)=>item.name).length===0?'text-[#706a6a]':'hover:text-[#008586] text-[#000000] cursor-pointer'}  `}
                                            />
                                        </li>
                                    </ul>
                                </li>
                            </ul>}
                        </div>}
                    </div>
                    {SearchInput && searchAdminCorporate && <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px] mb-[14px]">
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                    </button>}
                    {SearchInput && !searchAdminCorporate && <div className="relative ml-2.5 mb-[14px]">
                        <label htmlFor="input"></label>
                        <input
                            maxLength={90}
                            type="text"
                            id="search-value"
                            autoComplete='off'
                            value={suggestions}
                            autoFocus={suggestions !== ''}
                            onChange={(e) => { setSuggestions(e.target.value); optimizedFn(e.target.value) }}
                            className="pl-10 pr-[31px] w-[222px] py-2.5 border border-[#972E4C] rounded-[16px] placeholder:text-xs placeholder:font-normal placeholder:text-[#52555D] text-base font-normal text-[#000B17] outline-0" placeholder={SearchPlaceholder} />
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 left-3" />
                        <button onClick={() => { setSuggestions(""); optimizedFn("") }}>
                            {suggestions !== "" && <img src="/images/clear_search.svg" alt="icon" className="absolute top-1/2 -translate-y-1/2 right-2.5" />}
                        </button>


                        {/* <!-- <button className="absolute top-[50%] -translate-y-[50%] right-3.5 inline-block">
                <img loading="lazy" decoding="async" src="images/search.svg" alt="img"/>
            </button> --> */}

                    </div>}
                    <div className='flex items-center'>
                        <div className='xl:hidden block'>
                            {menuBar && <div className='relative ml-2.5 mb-[14px]'>
                                <button id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[10px] hover:bg-[#972E4C] focus:bg-[#972E4C] ${isChangeStatusOPenxl ? 'bg-[#972E4C]' : 'bg[#1111]'}`}
                                    onClick={() => { setIsChangeStatusOpenxl(!isChangeStatusOPenxl) }}
                                    onMouseEnter={() => setIsHover(true)}
                                    onMouseLeave={() => setIsHover(false)}
                                >
                                    {
                                        isHover || isChangeStatusOPenxl ? <img src="/images/3dots_white.svg" alt="img" /> : <img loading='lazy' decoding='async' src="/images/3_dots_color.svg" alt="img" />

                                    }
                                </button>
                                {isChangeStatusOPenxl && <ul ref={ref2} className='px-1.5 py-3 rounded-[6px] absolute top-12 right-5 bg-[#fff] min-w-[202px] shadow-s3 z-[2] '>
                                    <li className='pl-3 pr-[9px] py-1 text-base font-bold text-[#972E4C] mb-2'>Change Status</li>
                                    <li>
                                        <ul>
                                            <li>
                                                <AnimatedButton
                                                    handleClick={(e) => { handleActivateClick("activate") }}
                                                    buttonName={"Activate"}
                                                    disabled={(selectedRows?.filter((user)=>user.status==='inactive'))?.map((item)=>item.name).length===0?true:false}
                                                    className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user)=>user.status==='inactive'))?.map((item)=>item.name).length===0?'text-[#6e6d6d]':'hover:text-[#008586] text-[#000000] cursor-pointer'} `}
                                                />
                                            </li>
                                            <li>
                                                <AnimatedButton
                                                    handleClick={(e) => { handleActivateClick("deactivate") }}
                                                    buttonName={"Deactivate"}
                                                    disabled={(selectedRows?.filter((user)=>user.status==='active'))?.map((item)=>item.name).length===0?true:false}
                                                    className={`pl-3 pr-[9px] py-1 mb-2 text-base font-normal ${(selectedRows?.filter((user)=>user.status==='active'))?.map((item)=>item.name).length===0?'text-[#706a6a]':'hover:text-[#008586] text-[#000000] cursor-pointer'}  `}
                                                />
                                            </li>
                                        </ul>
                                    </li>
                                </ul>}
                            </div>}
                        </div>
                        {(ApplyFilter !== undefined && ApplyFilter) && 
                        <FilterBtn
                            isFilterOpen={isFilterOpen}
                            setIsFilterOpen={setIsFilterOpen}
                            handleApplyFilter={handleApplyFilter}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            isFilterOrganization={isFilterOrganization}
                            initialState={initialState}
                            isAdminActivity={true}
                            handleOpenFilter={handleOpenFilter}/>
                        }
                        {(SearchInput || AdminCorporateSearch || (isExport && data !== undefined && data?.data?.length > 0 ))&& (
                            <div>
                                {orgActivityExport ? (
                                    <OrgActivityExportFn
                                        selectedRows={selectedRows}
                                        exportOrgUsers={exportOrgUsers}
                                        exportCols={exportCols}
                                        setIsFilterOpen={setIsFilterOpen}
                                        isColumnSelect={isColumnSelect}
                                        setIsColumnSelect={setIsColumnSelect}
                                        isIdexport={isIdexport}
                                        username={username}
                                    />
                                ) : (
                                    data?.total_count>0&&<ExportFn
                                        selectedRows={selectedRows}
                                        exportUsers={exportUsers}
                                        exportCols={exportCols}
                                        setIsFilterOpen={setIsFilterOpen}
                                        isColumnSelect={isColumnSelect}
                                        setIsColumnSelect={setIsColumnSelect}
                                        isIdexport={isIdexport}
                                        username={username}
                                        isAdminActivity={true}
                                    />
                                )}
                            </div>
                        )}
                        {isExport && 
                        <>{<Link to={viewExportHistory}>
                            <button type='button'
                                id="view_export_history"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] mb-2.5`}>
                                View Export History
                            </button>
                        </Link>}</>}
                        {adminOrCorporateExport  && 
                        <>{<Link to={'/manage-admin-corporate/activity_history/export-history'} state={{"target_user_name":searchParams.get("target_user_name")}} >
                            <button type='button'
                                id="view_export_history"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] mb-2.5`}>
                                View Export History
                            </button>
                        </Link>}</>}
                        {AddButton && 
                        <>{<Link to={toAddScreen} state={{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),'search_mode':searchParams.get("search_mode"),'search':searchParams.get("search")?searchParams.get("search"):''}}>
                            <button type='button'
                                id="Add user"
                                className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5  mb-[14px]
bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                                {buttonName}
                            </button>
                        </Link>}</>}
                    </div>
                </div>
            </div>
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </>
       
    );
}

export default TopBar;
